export function FormInput({
  label,
  required = false,
  type = "text",
  value,
  onChange,
  placeholder = "",
  min,
  step,
}) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-900 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        min={min}
        step={step}
        required={required}
        className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 text-sm"
      />
    </div>
  );
}
